module.exports = __webpack_public_path__ + "img/coba.63620d58.png";